// extracted by mini-css-extract-plugin
export default {"online":"_700f0aa8","offline":"_9fc7f086"};